import React, { FC } from 'react';
import { Container } from 'react-bootstrap';
import BaseTemplate from '../BaseTemplate';
import LandscapeEditProjectsAddProjectTemplate from '../../../templates/LandscapeEditProjectsAddProjectTemplate';
import LandscapeProjectsEditProjectsImpactTemplate from '../../../templates/LandscapeProjectsEditProjectsImpactTemplate';
import styles from './LandscapeProjectsAddProjectsImpactCommodityTemplate.module.css';
import cn from 'classnames';
import { Button } from '../../atoms';
import {
  CommodityModal,
  LandscapeProjectsAddProjectsImpactCommodityOrganism,
} from '../../organisms';
import { CommodityResponseDto } from '../../../store/tradeAPI/commodity/dto/response/commodity-response.dto';

interface LandscapeProjectsAddProjectsImpactCommodityTemplateProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  commodities: CommodityResponseDto[];
  projectCommodities: CommodityResponseDto[];
  handleSubmit: () => void;
  handleDelete: (id: string) => void;
  handleEdit: (id: string) => void;
  setSelectedCommodity: React.Dispatch<
    React.SetStateAction<CommodityResponseDto | undefined>
  >;
}

const LandscapeProjectsAddProjectsImpactCommodityTemplate: FC<
  LandscapeProjectsAddProjectsImpactCommodityTemplateProps
> = ({
  showModal,
  setShowModal,
  commodities,
  projectCommodities,
  handleSubmit,
  handleDelete,
  handleEdit,
  setSelectedCommodity,
}) => {
  return (
    <>
      <BaseTemplate>
        <Container>
          <LandscapeEditProjectsAddProjectTemplate>
            <LandscapeProjectsEditProjectsImpactTemplate>
              <div className={cn(styles.landscapeAboutContactPersonsWrapper)}>
                <div className={cn(styles.button)}>
                  <Button variant="dark" onClick={() => setShowModal(true)}>
                    Add Commodity
                  </Button>
                </div>
                <div className={cn(styles.tableWrapper)}>
                  <LandscapeProjectsAddProjectsImpactCommodityOrganism
                    data={projectCommodities}
                    handleDelete={handleDelete}
                    handleEdit={handleEdit}
                  ></LandscapeProjectsAddProjectsImpactCommodityOrganism>
                </div>
              </div>
            </LandscapeProjectsEditProjectsImpactTemplate>
          </LandscapeEditProjectsAddProjectTemplate>
        </Container>
        {showModal && (
          <CommodityModal
            show={showModal}
            setShow={setShowModal}
            commodities={commodities}
            handleSubmit={handleSubmit}
            setSelectedCommodity={setSelectedCommodity}
          />
        )}
      </BaseTemplate>
    </>
  );
};

export default LandscapeProjectsAddProjectsImpactCommodityTemplate;
